import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BatchMarkDeliverableReadyMutation = ids =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation BatchMarkDeliverableReadyMutation($input: MarkReadyBatchDeliverableInput!) {
          markReadyBatchDeliverable(input: $input) {
            updatedDeliverables {
              id
              state
            }
          }
        }
      `,
      variables: {
        input: {
          ids
        }
      },
      onCompleted: res => resolve(res.markReadyBatchDeliverable),
      onError: reject
    });
  });

export default BatchMarkDeliverableReadyMutation;
